export enum Alerts {
    warning = 'fa-exclamation-circle',
    danger = 'fa-exclamation-triangle',
    info = 'fa-info-circle',
    success = 'fa-check-circle'
}
